import { CommonModule }    from '@angular/common';
import { FormsModule }     from '@angular/forms';
import { NgModule }        from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import {
  NgbModalModule,
  NgbProgressbarModule,
  NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';

import { BoxTogglerDirective }          from './box-toggler/box-toggler.directive';
import { ChosenDirective }              from './chosen/chosen.directive';
import { ControlClearerComponent }      from './control-clearer/control-clearer.component';
import { CopyToClipboardDirective }     from './copy-to-clipboard/copy-to-clipboard.component';
import { CssVariablesDirective }        from './css-variables/css-variables.directive';
import { DateNavComponent }             from './date-nav/date-nav.component';
import { DropdownComponent }            from './dropdown/dropdown.component';
import { EmptyStateComponent }          from './empty-state/empty-state.component';
import { FlipperComponent }             from './flipper/flipper.component';
import { FormSubmitValidatorDirective } from './form-submit.validator.directive';
import { GiveFocusDirective }           from './give-focus/give-focus.directive';
import { HotkeyDirective }              from './hotkey/hotkey.directive';
import { IconComponent }                from './icon/icon.component';
import { ImageViewModule }              from './image-viewer/image-viewer.module';
import { ListBoxComponent }             from './list-box/list-box.component';
import { NotificationComponent }        from './notification/notification.component';
import { PagerComponent }               from './pager/pager.component';
import { SaveRouteDirective }           from './save-route/save-route.directive';
import { SecretKeysComponent }          from './secret-keys/secret-keys.component';
import { StatCardComponent }            from './stat-card/stat-card.component';
import { SwitchFocusDirective }         from './switch-focus/switch-focus.directive';
import { TabBarComponent }              from './tab-bar/tab-bar.component';
import { ToggleSwitchComponent }        from './toggle-switch/toggle-switch.component';
import { TooltipDirective }             from './tooltip/tooltip.directive';
import { VideoViewerModule }            from './video-viewer/video-viewer.module';
import { WizardComponent }              from './wizard/wizard.component';
import { WizardStepComponent }          from './wizard/wizard.step.component';

@NgModule({
  declarations: [
    BoxTogglerDirective,
    ChosenDirective,
    ControlClearerComponent,
    CopyToClipboardDirective,
    CssVariablesDirective,
    DateNavComponent,
    DropdownComponent,
    EmptyStateComponent,
    FlipperComponent,
    FormSubmitValidatorDirective,
    GiveFocusDirective,
    HotkeyDirective,
    IconComponent,
    ListBoxComponent,
    NotificationComponent,
    PagerComponent,
    SaveRouteDirective,
    SecretKeysComponent,
    StatCardComponent,
    SwitchFocusDirective,
    TabBarComponent,
    ToggleSwitchComponent,
    TooltipDirective,
    WizardComponent,
    WizardStepComponent
  ],
  entryComponents: [
    ControlClearerComponent,
    CopyToClipboardDirective,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    SecretKeysComponent,
    WizardComponent,
    WizardStepComponent
  ],
  exports: [
    // Third Party
    CommonModule,
    FormsModule,
    NgbTooltipModule,

    // Custom
    BoxTogglerDirective,
    ChosenDirective,
    ControlClearerComponent,
    CopyToClipboardDirective,
    CssVariablesDirective,
    DateNavComponent,
    DropdownComponent,
    EmptyStateComponent,
    FlipperComponent,
    FormSubmitValidatorDirective,
    GiveFocusDirective,
    HotkeyDirective,
    IconComponent,
    ImageViewModule,
    ListBoxComponent,
    NotificationComponent,
    PagerComponent,
    SaveRouteDirective,
    SecretKeysComponent,
    StatCardComponent,
    SwitchFocusDirective,
    TabBarComponent,
    ToggleSwitchComponent,
    TooltipDirective,
    VideoViewerModule,
    WizardComponent,
    WizardStepComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Third Party
    NgbModalModule,
    NgbProgressbarModule,
    NgbTooltipModule,
    TranslateModule,

    //Custom
    ImageViewModule,
    VideoViewerModule
  ]
})
export class ComponentsModule {}
